module.exports = __webpack_public_path__ + "brunei.svg?09f380ca227f94ee808391b92928d4ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/brunei.svg
// module id = 121
// module chunks = 10